import { gql } from '@apollo/client';
import { ID_NAME_FIELDS } from 'graphql/common/fragments';

export const INDUSTRIES_QUERY = gql`
  query industries($search: IndustrySearchInput) {
    industries(search: $search) {
      ${ID_NAME_FIELDS}
      category
    }
  }
`;
